// extracted by mini-css-extract-plugin
export default {"recommendationContainer":"styles_recommendationContainer__8aAYy","recommendationIcon":"styles_recommendationIcon__1QH+n","recommendationTypo":"styles_recommendationTypo__sDwdF"};